import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import EventMg from '../utilities/EventManager';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import {
  USER_ROLES,
  REQUEST_PARAMS, // API LIMIT
  HEADER_CONSTANTS, // ヘッダータイトル
  PARTNER_COMPANY_REGISTER_LOAD_FROM,
} from '../utilities/constants';
import dialogLoader from '../utilities/dialogLoader';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import CompanyService from '../services/Companies';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { CompanyBranchService } from '../services/CompanyBranches'; // 支店マスタAPI
import { PartnerCompanyContents } from '../components/tables/PartnerCompanies'; // テーブ表示部分
import { PartnerCompaniesSearchForm } from '../components/searchmenus/PartnerCompanies'; // 検索フォーム
import { csvDownloader } from '../utilities/commonUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { PartnerCompanyAddDialog } from '../components/PartnerCompanyAddDialog';
import Information from '../components/modals/common/Information';
import { FormInformationDialog } from '../components/FormInformationDialog';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { addPartnerCompanySucessDialog } from '../styles/organisms/add-partner-company-success-dialog.scss';

const MY_EVENT = {
  LOAD_PARTNER_COMPANIES: 'load_partner_companies', // 一覧取得
};

/**
 * @description 協力会社一覧画面
 */
export class PartnerCompanies extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false, // 検索フォーム開閉フラグ
      isLoading: true, // ロード中フラグ
      loaded: false, // 全件取得済みフラグ
      total: 0, // 総数
      partnerCompanies: {}, // 協力会社一覧
      fieldId: SessionStorageService.getFieldId(), // 選択した現場ID
      searchConditions: {
        // 検索条件
        name: '',
        address: '',
        tel: '',
        permission_number: '',
        joining_flag: null, // 共通化状態
      },
      csvSearchConditions: {
        // 検索条件
        name: '',
        address: '',
        tel: '',
        permission_number: '',
        joining_flag: null, // 共通化状態
      }, // 検索条件(CSV用)
      showDuplicateDialog: false,
      searchOnLoadFlag: false, // 遷移時に検索ダイアログを表示したフラグ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.getPartnerCompanies = this.getPartnerCompanies.bind(this); // 一覧取得

    this.events = {
      search: {
        handleOpen: this.handleFormOpen.bind(this), // 検索フォーム開閉イベント
        set: this.setCondition.bind(this), // 検索条件セット
        clear: this.clearConditions.bind(this), // 検索条件クリア
        execution: this.searchExecution.bind(this), // 検索実行
      },
      table: {
        edit: this.editRow.bind(this), // 編集画面へ遷移
        list: this.movePartnerUsers.bind(this), // 協力会社ユーザー一覧画面へ遷移
      },
      output: this.csvDownloadPreparation.bind(this), // CSV出力
    };
    this.searchButtonRef = React.createRef(); // 検索ボタン要素

    // 一覧取得イベント登録
    EventMg.registerEvent(MY_EVENT.LOAD_PARTNER_COMPANIES);
    EventMg.addEventListener(MY_EVENT.LOAD_PARTNER_COMPANIES, () => {
      let state = this.state;
      state.loaded = false;
      state.partnerCompanies = {};
      state.searchConditions.name = '';
      state.searchConditions.address = '';
      state.searchConditions.tel = '';
      state.searchConditions.permission_number = '';
      state.searchConditions.joining_flag = null;
      this.setState(state);
      this.getPartnerCompanies(() => {});
    });

    this.updatingFlag = false;
    this.searchingFlag = false;
    this.isDownloadingFlag = false;
  }

  checkForPreviousSearch = () => {
    if (
      _.has(this.props.view.state, 'cacheParam') &&
      !_.isNull(this.props.view.state.cacheParam) &&
      !this.state.searchOnLoadFlag
    ) {
      return true;
    }
    return false;
  };

  componentDidMount() {
    this._isMounted = true;
    this.getPartnerCompanies(() => {});
    if (this.checkForPreviousSearch()) {
      this.showAddCompanyDialog();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    EventMg.deleteEvent(MY_EVENT.LOAD_PARTNER_COMPANIES);
  }

  /**
   * 検索フォーム開閉
   */
  handleFormOpen = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * 編集画面へ遷移
   * @param partnerCompany {object}
   */
  editRow = partnerCompany => {
    // 協力会社ID.支店ID
    const param = {
      state: {
        id: `${partnerCompany.id}.${partnerCompany.company_branch.id}`,
      },
    };
    _masterSlideLoader.show('PartnerCompanyPreview', param);
  };

  /**
   * 協力会社ユーザー一覧画面へ遷移
   * @param partnerCompany {object}
   */
  movePartnerUsers = partnerCompany => {
    const {
      id,
      joining_flag: joiningFlag,
      company_branch: companyBranch,
    } = partnerCompany;
    SessionStorageService.setPartnerCompanyJoiningFlag(joiningFlag);
    // 協力会社ID.支店ID
    const param = {
      state: {
        id: `${id}.${companyBranch.id}`,
      },
    };
    _masterSlideLoader.show('PartnerUsers', param);
  };

  /**
   * 検索条件クリア
   */
  clearConditions = () => {
    if (this.searchingFlag) {
      return;
    }
    this.searchingFlag = true;
    const searchConditions = {
      name: '',
      address: '',
      tel: '',
      permission_number: '',
      joining_flag: null,
    };
    this.setState(
      {
        loaded: false,
        partnerCompanies: {},
        searchConditions,
        csvSearchConditions: searchConditions,
        isLoading: true,
      },
      () => this.getPartnerCompanies(() => {})
    );
  };

  /**
   * 検索条件セット
   */
  setCondition = e => {
    const searchConditions = { ...this.state.searchConditions };
    searchConditions[e.target.name] = e.target.value;
    this.setState({ searchConditions });
  };

  /**
   * @description 検索実行
   */
  searchExecution() {
    if (this.searchingFlag) {
      return;
    }
    this.searchingFlag = true;
    this.searchButtonRef.current.disabled = true;
    this.setState(
      {
        loaded: false,
        partnerCompanies: {},
        isLoading: true,
        csvSearchConditions: this.state.searchConditions,
      },
      () => this.getPartnerCompanies(() => {})
    );
  }

  /**
   * 一覧取得
   */
  getPartnerCompanies(notify) {
    if (this.state.loaded || !this._isMounted) {
      notify();
      this.setState({ isLoading: false });
      this.searchingFlag = false;
      return;
    }

    const params = {
      ...this.state.csvSearchConditions,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.partnerCompanies),
    };

    CompanyBranchService.companyPartnerList(params, true).then(response => {
      if (response.result) {
        const companies = response.data.entities.company;
        if (_.isEmpty(companies)) {
          this.setState({
            loaded: true,
            total: response.data.total,
          });
        } else {
          let partnerCompanies = this.state.partnerCompanies;
          _.each(companies, company => {
            partnerCompanies[company.company_branch.id] = company;
          });
          this.setState({
            partnerCompanies,
            loaded: false,
            total: response.data.total,
          });
        }
      }
      notify();
    }).finally(() => {
      this.searchButtonRef.current.disabled = false;
      this.searchingFlag = false;
      this.setState({ isLoading: false });
    });
  }

  /**
   * @description CSV出力準備
   */
  async csvDownloadPreparation() {
    if (this.isDownloadingFlag) {
      return;
    }
    this.isDownloadingFlag = true;
    const params = _.cloneDeep(this.state.csvSearchConditions);
    const apiPath = 'api/private/company_branches/company_partner_list.csv';

    await csvDownloader(apiPath, params);
    this.isDownloadingFlag = false;
  }

  showDuplicateDialog = () => {
    this.setState({
      showDuplicateDialog: true,
    });
  };

  closeDuplicateDialog = () => {
    this.setState({
      showDuplicateDialog: false,
    });
  };

  /**
   * 一覧で選択した協力会社がBuildee未加入のため新規登録画面へ遷移
   * @param data {object} 選択項目データ
   */
  createCompany = data => {
    dialogLoader.close();
    masterSlideLoader.show('PartnerCompanyPersonalRegister', {
      state: {
        listData: data,
        loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.PARTNER_COMPANIES,
      },
    });
  };

  // Buildee加入済みで協力会社一覧にない会社を追加する
  addJoiningCompany = async confirmValues => {
    let juridical_personality_code = '';
    let juridical_personality_number = '';

    if (confirmValues.company.personal_flag !== 1) {
      juridical_personality_code =
        confirmValues.company.juridical_personality_code;
      juridical_personality_number = confirmValues.company.company_number; // リファクタ前(TaxMasterList)の仕様を継続。juridical_personality_numberはBuildee加入済みの場合、company_numberを使用する
    }

    const params = {
      is_person: confirmValues.company.personal_flag === 1,
      joining_flag: 1,
      name: confirmValues.company.name,
      kana: confirmValues.company.kana,
      juridical_personality_code,
      juridical_personality_number,
      postal_code: confirmValues.company.postal_code,
      prefectures_code_id: confirmValues.company.prefectures_code_id,
      city_name: confirmValues.company.city_name,
      street_number: confirmValues.company.street_number,
      building_name: confirmValues.company.building_name,
      tel: confirmValues.company.tel,
      fax: confirmValues.company.fax,
      company_id: confirmValues.company.id,
      personal_flag: confirmValues.company.personal_flag,
      company_number: confirmValues.company.company_number,
    };

    this.updatingFlag = true;
    CompanyService.create(params)
      .then(response => {
        if (response.result) {
          if (response.duplicate_flag === true) {
            this.showDuplicateDialog();
          } else {
            const addCompanyTitle =
              _.get(response, 'data.entities.company.name', '') || '';
            dialogLoader.show(FormInformationDialog, {
              title: '協力会社の追加完了',
              message: `${addCompanyTitle}を追加しました。`,
              rootClassName: addPartnerCompanySucessDialog,
              onClose: () => {
                dialogLoader.close();
                masterSlideLoader.show(
                  'PartnerCompanies',
                  { state: { id: 1 } },
                  this.props.vw
                );
                this.clearConditions();
              },
            });
          }
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  showAddCompanyDialog = () => {
    let options = {};
    // cacheParamがある場合検索条件を引き継ぐ
    if (this.checkForPreviousSearch()) {
      options.cacheParam = this.props.view.state.cacheParam;
    }
    dialogLoader.show(
      PartnerCompanyAddDialog,
      {
        state: {
          similarCompanyExists: false,
          options,
        },
        loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.PARTNER_COMPANIES,
        callback: {
          close: () => {
            // 登録をやめる
            dialogLoader.close();
          },
          back: () => {
            // 戻る
          },
          create: () => {
            dialogLoader.close();
            masterSlideLoader.show('PartnerCompanyPersonalRegister', {
              state: {
                loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.PARTNER_COMPANIES,
              },
            });
          },
          showDuplicateDialog: () => {
            dialogLoader.close();
            this.showDuplicateDialog();
          },
          createCompany: data => {
            this.createCompany(data);
          },
          submit: async (formValues, confirmValues) => {
            await this.addJoiningCompany(confirmValues);
          },
          resetUpdatingFlag: () => {
            this.updatingFlag = false;
          },
        },
      },
      this.props.vw
    );
    // propsのcacheParamを初期以外使わないようにフラグを立てる
    this.setState({ searchOnLoadFlag: true });
  };

  render() {
    const roleId = localStorage.getItem('role_id');
    const styles = {
      masterSlideViewTable: {
        height: 'calc(100vh - 40px)',
      },
    };
    return (
      <div id='slide-view' className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 協力会社一覧</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={'協力会社一覧'}
            onClose={() => {
              _masterSlideLoader.close();
            }}
          />

          <div
            id='infinityscroll-target'
            className='master-slide-view__table'
            style={styles.masterSlideViewTable}
          >
            <div className='master-slide-view__menu'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button
                    className='btn'
                    onClick={() => this.showAddCompanyDialog()}
                  >
                    新規作成
                  </button>
                </li>
                <li className='btn-menu__item --fx-auto sm--hidden' />
                <li className='btn-menu__item'>
                  <button
                    className='btn--sub'
                    style={
                      roleId > USER_ROLES.prime.id
                        ? { display: 'none' }
                        : { display: 'block' }
                    }
                    onClick={this.events.output}
                  >
                    表示データをCSV出力
                  </button>
                </li>
              </ul>
            </div>
            <PartnerCompaniesSearchForm
              total={this.state.total}
              isOpened={this.state.isOpened}
              conditions={this.state.searchConditions}
              callbacks={this.events.search}
              searchButtonRef={this.searchButtonRef}
            />
            <div className='master-slide-view__body'>
              <div className='constructionlist__list'>
                <table className='table table--constructionlist__list'>
                  <thead className='table__header'>
                    <tr className='table__label'>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>会社名</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>住所</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>電話番号</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>登録日</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>更新日</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div
                          className='value-table__label'
                          style={{ textAlign: 'center' }}
                        >
                          共通
                        </div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div
                          className='value-table__label'
                          style={{ textAlign: 'center' }}
                        >
                          ユーザー数
                        </div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label' />
                      </td>
                    </tr>
                  </thead>
                  <PartnerCompanyContents
                    data={this.state.partnerCompanies}
                    callbacks={this.events}
                  />
                </table>
                <InfinityScrollLoad
                  targetId={`infinityscroll-target`}
                  total={this.state.total}
                  isLoading={this.state.isLoading}
                  callback={this.getPartnerCompanies}
                />
              </div>
            </div>
          </div>
          <Information
            visible={this.state.showDuplicateDialog}
            title={messageUtility.getMessage('I-000-133')}
            buttonText={messageUtility.getMessage('I-000-017')} // 閉じる
            message={messageUtility.getMessage('E-000-054')}
            onClose={() => this.closeDuplicateDialog()}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerCompanies.jsx